import { LuPlus } from "react-icons/lu";
import SectionHeading from "./SectionHeading";

export default function TermsStep({
  termsConditions,
  setTermsConditions,
  customTerms,
  setCustomTerms,
  paymentTerm,
  setPaymentTerm,
  PAYMENT_TERMS,
}) {
  return (
    <div>
      <SectionHeading>Terms and Conditions</SectionHeading>
      <div className="space-y-2">
        {termsConditions.map((t, i) => (
          <label key={i}
            className="flex items-start gap-2.5 rounded-lg border border-slate-200 p-2.5 text-[13px] text-slate-700 transition-colors hover:bg-slate-50"
          >
            <input
              type="checkbox"
              checked={t.checked}
              onChange={(e) =>
                setTermsConditions((prev) => {
                  const next = [...prev];
                  next[i] = { ...next[i], checked: e.target.checked };
                  return next;
                })
              }
              className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-brand-600"
            />
            {t.text}
          </label>
        ))}
        {customTerms.map((t, i) => (
          <label key={i} className="flex items-start gap-2.5 rounded-lg border border-slate-200 p-2.5 text-[13px] text-slate-700">
            <input
              type="checkbox"
              checked={t.checked}
              disabled={!t.text.trim()}
              onChange={(e) =>
                setCustomTerms((prev) => {
                  const next = [...prev];
                  next[i] = { ...next[i], checked: e.target.checked };
                  return next;
                })
              }
              className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-brand-600"
            />
            <input
              value={t.text}
              onChange={(e) =>
                setCustomTerms((prev) => {
                  const next = [...prev];
                  next[i] = { ...next[i], text: e.target.value };
                  return next;
                })
              }
              placeholder="Enter custom term/condition"
              className="flex-1 rounded-md border border-slate-200 px-2 py-1 text-[13px] outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
            />
          </label>
        ))}
        <button
          onClick={() => setCustomTerms((prev) => [...prev, { checked: true, text: "" }])}
          className="flex items-center gap-1.5 rounded-lg bg-teal-600 px-3 py-1.5 text-[12px] font-medium text-white transition hover:bg-teal-700"
        >
          <LuPlus size={13} /> Add Custom Term/Condition
        </button>
      </div>

      <div className="mt-6">
        <p className="mb-2 text-[12px] font-medium text-slate-600">
          Payment Terms<span className="ml-0.5 text-red-500">*</span>
        </p>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {PAYMENT_TERMS.map((pt) => {
            const active = paymentTerm === pt.value;
            return (
              <label key={pt.value}
                className={`flex cursor-pointer items-center gap-2.5 rounded-lg border p-2.5 text-[13px] transition-colors ${
                  active ? "border-brand-400 bg-brand-50/60 text-brand-800" : "border-slate-200 text-slate-700 hover:bg-slate-50"
                }`}
              >
                <input type="radio" name="paymentTerm" checked={active} onChange={() => setPaymentTerm(pt.value)} className="h-4 w-4 shrink-0 border-slate-300 text-brand-600" />
                {pt.label}
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
}